import PropTypes from 'prop-types';
import React from 'react';

import { DeepsightComponentLoader, InpulseLabel } from '@commons/DeepsightComponents';
import { roundWithDecimals } from '@commons/utils/math';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import { Container, LoadingContainer, ValueColumn } from './styledComponents';

const EVOLUTION_DECIMALS = 1;

/**
 * Metric tile of the external client detail page: the current-year value and its year-over-year
 * evolution badge. The badge is hidden when the evolution is null — no order on the previous
 * period, so there is nothing to compare against (COR-1724).
 */
const ClientMetricCard = ({ title, value, evolution, isLoading }) => {
  const hasEvolution = evolution !== null && evolution !== undefined;

  const roundedEvolution = hasEvolution ? roundWithDecimals(evolution, EVOLUTION_DECIMALS) : null;

  const evolutionLabel = hasEvolution
    ? `${roundedEvolution > 0 ? '+' : ''}${roundedEvolution}%`
    : '';

  return (
    <Container>
      {isLoading && (
        <LoadingContainer>
          <DeepsightComponentLoader height={16} width={16} />
        </LoadingContainer>
      )}
      {!isLoading && (
        <>
          <ValueColumn>
            <Text color={ENUM_COLORS.DARKER} font={ENUM_FONTS.TEXT_SMALL_HEIGHT_16}>
              {title}
            </Text>
            <Text font={ENUM_FONTS.TEXT_SMALL_HEIGHT_14_WEIGHT_700_BOLD}>{value}</Text>
          </ValueColumn>
          {hasEvolution && (
            <InpulseLabel
              color={roundedEvolution < 0 ? 'red' : 'green'}
              text={evolutionLabel}
              type={'secondary'}
            />
          )}
        </>
      )}
    </Container>
  );
};

ClientMetricCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  evolution: PropTypes.number,
  isLoading: PropTypes.bool,
};

ClientMetricCard.defaultProps = {
  evolution: null,
  isLoading: false,
};

export default ClientMetricCard;
